import './styles/index.css';

import { mountStarfield } from './components/starfield';
import { renderNav } from './components/nav';
import { renderHero } from './components/hero';
import { renderPillars } from './components/pillars';
import { renderManifesto } from './components/manifesto';
import { renderOrbit } from './components/orbit';
import { renderFooter } from './components/footer';
import { observeReveals } from './lib/motion';

const app = document.getElementById('app');
if (!app) throw new Error('#app not found');

app.append(
  renderNav(),
  (() => {
    const main = document.createElement('main');
    main.id = 'main';
    main.append(
      renderHero(),
      renderPillars(),
      renderOrbit(),
      renderManifesto(),
    );
    return main;
  })(),
  renderFooter(),
);

mountStarfield(document.body);
observeReveals();
